 $(document).ready(function() {
 	if ($('#LPGtxtSlider').length > 0) {

     var LpgSlider = tns({
         container: '#LPGtxtSlider',
         items: 1,
         slideBy: 1,
         loop: true,
         nav: true,
         navContainer: '.lpgSlider_nav',
         prevButton: '.lpg_prev',
         nextButton: '.lpg_next',
         speed: 500,
         responsive: {
                "998": {
                    nav: false
                }
            }
     });

 }
});
